import InfoTooltip from '@/components/ui/InfoTooltip';

export default function PageHeader({ title, hint, action }) {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-display font-bold text-gray-900 dark:text-white">
          {title}
        </h1>
        {hint && <InfoTooltip text={hint} size={16} />}
      </div>
      {action}
    </div>
  );
}
